<div *ngIf="isMobile; else webLogin" class="full-container">
  <!-- <div class="mobile-header">
    <div class="mobile-title">
      P2P Bidding
    </div>
    <img class="mobile-logo" src="assets/hygge_hamburger_menu.png" alt="hygge_hamburger_menu">
  </div> -->
  <div class="bidding-container">
    <div class="top-content" [ngClass]="{'preferential-energy-class': isCustomRangeSelected()}">
      <div class="bid-info-mobile">
        <div [ngClass]="{'bid-info-buy-mobile': transactionType === 'buy', 'bid-info-sell-mobile': transactionType === 'sell'}">
          <div class="bid-type-mobile">
            <span class="bid-type-label-mobile">Bid Type -&nbsp;</span>
            <span class="type-mobile">{{ transactionType | titlecase }}</span>
          </div>
        </div>
        <div class="instruction-mobile">
          Please enter details about your <br> Energy {{ offer }} and Submit
        </div>
      </div>
      <div class="form-container-mobile">
        <form [formGroup]="BiddingForm" (ngSubmit)="onSubmit()" #biddingForm="ngForm">
          <div class="bid-form-box">
            <div class="form-group-mobile">
              <div class="form-label-mobile">Select Bid Category</div>
              <select class="form-control-mobile custom-select" formControlName="bidCategory" (change)="onBidCategoryChange($event)">
                <option *ngFor="let round of bidRounds" [value]="round.type">
                  {{ round.type }}
                </option>
              </select>
            </div>

            <div *ngIf="!isCustomRangeSelected()">
              <div class="form-group-mobile">
                <div class="form-label-mobile">Select from Date</div>
                <select class="form-control-mobile" formControlName="bidRound">
                  <option *ngFor="let r of filteredBidRoundData" [value]="r.id">
                    {{ r.start_trade_period_label }}
                  </option>
                </select>
              </div>
            </div>

            <div *ngIf="isCustomRangeSelected()">
              <div class="form-group-mobile">
                <div class="form-label-mobile">Input Partner's Customer ID </div>
                <input type="number" class="form-control-mobile" formControlName="customerId">
              </div>
            </div>

            <div *ngIf="isCustomRangeSelected()">
              <div class="form-group-mobile">
                <div class="form-label-mobile">Select your Start Date</div>
                <input type="date" class="form-control-mobile" [min]="minDate" formControlName="startDate">
              </div>
            </div>

            <div *ngIf="isCustomRangeSelected()">
              <div class="form-group-mobile">
                <div class="form-label-mobile">Select your End Date</div>
                <input type="date" class="form-control-mobile" [min]="minAfterDate" formControlName="endDate">
              </div>
            </div>
            
            <div class="form-group-mobile">
              <div class="form-label-mobile">Enter Number of Units (Kwh)</div>
              <input type="number" class="form-control-mobile" formControlName="numberOfUnits" step="0.01" min="0.01" appDecimalPositive>
              <div *ngIf="number_of_units?.invalid && (number_of_units?.dirty || number_of_units?.touched)">
                <div class="error-mobile" *ngIf="number_of_units?.errors?.['required']">
                  Number of units is required.
                </div>
                <div class="error-mobile" *ngIf="number_of_units?.errors?.['notPositive']">
                  Number of units must be greater than 0.
                </div>
              </div>
            </div>

            <div class="form-group-mobile">
              <div class="form-label-mobile">Enter {{ transactionType === 'buy' ? 'Buy' : 'Sell' }} - Bid rate (Rs.)</div>
              <input type="number" class="form-control-mobile" formControlName="bidRate" step="0.01" min="0.01" appDecimalPositive>
              <div *ngIf="bid_rate?.invalid && (bid_rate?.dirty || bid_rate?.touched)">
                <div class="error-mobile" *ngIf="bid_rate?.errors?.['required']">
                  Bid rate is required.
                </div>
                <div class="error-mobile" *ngIf="bid_rate?.errors?.['notPositive']">
                  Bid rate must be greater than 0.
                </div>
              </div>
            </div>
          </div>
        </form>
        <div *ngIf="errorMessage" class="error">
          {{ errorMessage }}
        </div>
      </div>
    </div>

    <div class="bottom-content">
      <div class="cancel-and-submit-buttons">
        <div class="cancel-button-mobile">
            <button (click)="navigateTo('market')">Cancel</button>
        </div>
        <div class="submit-button-mobile">
            <button type="submit" (click)="biddingForm.ngSubmit.emit()" [disabled]="!BiddingForm.valid">Submit</button>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #webLogin>
  <div class="container">
    <div class="main-content">
      <div class="bid-info">
        <div [ngClass]="{'bid-info-buy': transactionType === 'buy', 'bid-info-sell': transactionType === 'sell'}">
          <div class="bid-type">
            <span class="bid-type-label">Bid Type</span>: {{ transactionType | titlecase }}
          </div>
        </div>
        <!-- <div *ngIf="isLoading" class="loading-web">
          Placing the bid, please wait...
        </div> -->
        <div *ngIf="isLoading" class="loading-web">
              {{ loadingMessage }}
       </div>
        <div class="instruction">
          Please enter details about your Energy {{ offer }} and Submit
        </div>
      </div>
      <div class="back-button" >
        <div class="button-text" (click)="goBack()">BACK</div>
      </div>
      <form [formGroup]="BiddingForm" (ngSubmit)="onSubmit()">
        <div class="form-section">
          <div class="form-row">
            <div class="form-column">
              <div class="form-group">
                <div class="form-label">Select bid Category</div>
                <select class="form-control custom-select" formControlName="bidCategory" (change)="onBidCategoryChange($event)">
                   <option value="" disabled [selected]="!BiddingForm.get('bidCategory')?.value">-- Choose category --</option>
          <option *ngFor="let round of bidRounds" [value]="round.type">
            {{ round.type }}
          </option>
                </select>
              </div>
            </div>
            <div *ngIf="!isCustomRangeSelected()" class="form-column">
              <div class="form-group">
                <div class="form-label">Select from Date</div>
                <select class="form-control" formControlName="bidRound">
                 <option [value]="null" disabled [selected]="!BiddingForm.get('bidRound')?.value">-- Please select a period --</option>
          <option *ngFor="let r of filteredBidRoundData" [value]="r.id">
            {{ r.start_trade_period_label }}
          </option>
                </select>
              </div>
            </div>
            <div *ngIf="isCustomRangeSelected()" class="form-column">
              <div class="form-group">
                <div class="form-label">Input Partner's Customer ID </div>
                <div class="userId-userName">
                  <input type="number" class="form-control" formControlName="customerId" (blur)="onCustomerIdBlur()">
                  <input type="text" class="form-control username-input" [value]="userName" readonly *ngIf="userName">
                </div>
              </div>
            </div>
          </div>

          <div *ngIf="isCustomRangeSelected()" class="form-row">
            <div class="form-column">
              <div class="form-group">
                <div class="form-label">Select your Start Date</div>
                <input type="date" class="form-control" [min]="minDate" formControlName="startDate">
              </div>
            </div>
            <div class="form-column">
              <div class="form-group">
                <div class="form-label">Select your End Date</div>
                <input type="date" class="form-control" [min]="minAfterDate" formControlName="endDate">
              </div>
            </div>
          </div>

          <div class="form-row">
            <div class="form-column">
              <div class="form-group">
                <div class="form-label">Enter Number of Units [Kwh]</div>
                <input type="number" step="0.01" min="0.01" class="form-control" formControlName="numberOfUnits" appDecimalPositive>
                <div *ngIf="number_of_units?.invalid && (number_of_units?.dirty || number_of_units?.touched)">
                  <div class="error-message" *ngIf="number_of_units?.errors?.['required']">
                    Number of units is required.
                  </div>
                  <div class="error-message" *ngIf="number_of_units?.errors?.['notPositive']">
                    Number of units must be greater than 0.
                  </div>
                </div>
              </div>
            </div>
            <div class="form-column">
              <div class="form-group">
                <div class="form-label">Enter {{ transactionType === 'buy' ? 'Buy' : 'Sell' }} - Bid rate [Rs.]</div>
                <input type="number"step="0.01" min="0.01"  class="form-control" formControlName="bidRate" appDecimalPositive>
                <div *ngIf="bid_rate?.invalid && (bid_rate?.dirty || bid_rate?.touched)">
                  <div class="error-message" *ngIf="bid_rate?.errors?.['required']">
                    Bid rate is required.
                  </div>
                  <div class="error-message" *ngIf="bid_rate?.errors?.['notPositive']">
                    Bid rate must be greater than 0.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="action-buttons">
          <div class="cancel-button" (click)="navigateTo('market')" [class.disabled] = "isLoading">Cancel</div>
          <button type="submit" class="submit-button" [disabled]="!BiddingForm.valid || isLoading">Submit</button>
        </div>
      </form>
      <div *ngIf="errorMessage" class="error-message">
        {{ errorMessage }}
      </div>
      
    </div>
  </div>
</ng-template>